<template>
  <v-dialog v-model="dialog" width="400" persistent>
    <v-card :disabled="loading">
      <v-card-title>
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn @click="close()" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="mt-5">
        <v-text-field v-model="color" filled autofocus></v-text-field>

        <v-select
          v-if="!hideDarkInput"
          v-model="dark"
          :label="__('tema')"
          filled
          :items="themeItems"
        ></v-select>
      </v-card-text>

      <v-card-actions>
        <v-btn @click="submit" color="primary" block :loading="loading">
          {{ __("Salvar") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogsMixin from "@/mixins/DialogsMixin.vue";
import i18n from "@/mixins/i18n";

export default {
  mixins: [DialogsMixin, i18n],

  components: {},

  props: {
    title: String,
    hideDarkInput: Boolean,
  },

  data() {
    return {
      i18n_prefix: "settings",
      color: null,
      dark: true,
      themeItems: [
        {
          text: this.__("claro", "settings"),
          value: false,
        },
        {
          text: this.__("escuro", "settings"),
          value: true,
        },
      ],
    };
  },

  methods: {
    open(color) {
      this.color = color;
      this.dialog = true;
    },
    submit() {
      this.$emit("submit", {
        color: this.color,
        dark: this.hideDarkInput ? undefined : this.dark,
      });
    },
  },

  computed: {},
};
</script>
